export enum MarketingCampaignStatus {
  DRAFT = 'draft',
  RUNNING = 'running',
  PAUSED = 'paused',
  STOPPED = 'stopped',
}

export enum MarketingContactStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  REPLIED = 'replied',
  CONVERTED = 'converted',
  UNSUBSCRIBED = 'unsubscribed',
  COMPLETED = 'completed',
}

export interface MarketingCampaignSettings {
  id: number;
  aliasId: string;
  campaignName: string;
  status: MarketingCampaignStatus;
  dailyCap: number;
  allowedDaysOfWeek: number[];
  sendWindowStartHour: number;
  sendWindowEndHour: number;
  waveStartDate: string | null;
  deadlineDate: string | null;
  updatedByAdmin: string | null;
}

export interface ApiMarketingCampaignGetSettingsResponse {
  settings: MarketingCampaignSettings;
  counts: Record<MarketingContactStatus, number>;
  sentToday: number;
}

export interface ApiMarketingCampaignUpdateSettingsRequest {
  dailyCap?: number;
  allowedDaysOfWeek?: number[];
  sendWindowStartHour?: number;
  sendWindowEndHour?: number;
  waveStartDate?: string;
  deadlineDate?: string;
}

export interface MarketingContact {
  id: number;
  aliasId: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  timezone: string | null;
  campaignName: string;
  currentStep: number;
  status: MarketingContactStatus;
  nextSendAt: string | null;
  lastSentAt: string | null;
  repliedAt: string | null;
  convertedAt: string | null;
  unsubscribedAt: string | null;
}

export interface ApiMarketingCampaignGetContactsResponse {
  contacts: MarketingContact[];
  total: number;
}

export interface ApiMarketingCampaignGetContactsQuery {
  status?: MarketingContactStatus;
  currentStep?: number;
  offset?: number;
  limit?: number;
}

export interface ApiMarketingCampaignImportCsvResponse {
  created: number;
  skippedInvalid: number;
  skippedDuplicate: number;
  skippedNoUser: number;
  skippedPaidPlan: number;
  skippedAlreadyEnrolled: number;
}

export interface ApiMarketingCampaignSendTestEmailRequest {
  email: string;
  step: number;
}

export interface ApiMarketingCampaignSendTestEmailResponse {
  sent: boolean;
}
